import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import PropTypes from 'prop-types'
import videojs from "video.js";
import "video.js/dist/video-js.css";
import hotkeys from "hotkeys-js";
import PlayerConstants from '../../../utils/PlayerConstants';
// import { pathCreater,ASSET_PATH } from "../../../utils/MediaConfig";
import './videocontainer.scss'
import './videocontrols.scss'
import './overlaypropsetter.scss'
import CuePoints from '../Video/CuePoints'
import OverLayRender from '../Video/OverLayRender';
import VideoContentText from "../Video/VideoContentText";
import Instruction from "../../ui/Instruction/Instruction";
import SubtitlesIcon from '@material-ui/icons/Subtitles';
import CuePoint from "../../../utils/Cuepoint";
import DataHelper from "../../../utils/DataHelper";
import BuildHelper from "../../../utils/BuildHelper";
import { pathCreater } from "../../../utils/MediaConfig";
import ComponentConstants from '../../../utils/ComponentConstants';
import t from "../../../translation/useTranslate";
import MuiIcons from "../../ui/MuiIcons/MuiIcons" /// multicontent check

/**
 * 
 * @param {*} src 
 * @returns video source url of the component
 */

/**
 * 
 * @param {*} cuepoints 
 * @returns cuepoints array for the video for the displaying message
 */

/**
 * 
 * @param {*} color 
 * @returns display colors of the cuepoints
 */

/**
 * 
 * @param {*} poster 
 * @returns Url for background overlay image
 */

/**
 * 
 * @param {*} readable 
 * @returns innerhtml string for rendering some content
 */

/**
 * video player interactivity content component can be customized using below props 
*/
const ArchiveVideo = ({ src, cuepoints, colors, poster,has_cc, readable, track, handler, cename, instructions, description, content, subtitleurl, topic_id,ccid, playbackRates, forward_rewind, hasCue, fast_forward}) => {
    const userInfo = {};
    userInfo.user = window?.ce?.ceuser;
    const videoPlayerRef = useRef(null);
    if (track === undefined || handler === undefined) {
        track = {}
        handler = () => {

        }
    }
    // console.log('track video', track, handler)
    const UPDATE_STATUS = PlayerConstants.COMPONENT_CONSTANTS.UPDATE_STATUS
    const SAVE_PROGRESS_STATUS = PlayerConstants.COMPONENT_CONSTANTS.SAVE_PROGRESS_STATUS

    const [playerReady, setPlayerReady] = useState(false);
    const [isOverLay, setOverLay] = useState(false)
    const [duration, setDuration] = useState(0)
    const [status, setStatus] = useState({ completed: false, text: 'Pending' })
    const [isDragEnabled, setDragEnabled] = useState(false)
    const [instruction, setInstruct] = useState(instructions)
    const [showTextVersion, setTextVersionVersion] = useState(false)
    const [TextVersion, setTextVersion] = useState('');
    const [currentCue, setCurrentCue] = useState({})
    const [player, setPlayer] = useState({});
    const [viewInDevice, setViewDevice ] = useState("Desktop");
    const [showCCTextVersion, setCCTextVersion] = useState(false)
    const [controlArea, setControlArea ] = useState(null);

    const videoAsp = () => {
        let contentAreaWidth = document?.getElementsByClassName('content')[0]?.clientWidth;
        return DataHelper.getVideoAspectRatio(contentAreaWidth)
    }
    const [videAsp, setVideoAsp] = useState(videoAsp);

    useLayoutEffect(() => {
        function updateSize() {
            setVideoAsp(videoAsp);
            // console.debug("videAsp",videAsp)
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    // useEffect(()=>{
    //     console.log("position i am in",);
    //     let element = document.getElementsByClassName('vjs-progress-control');
    //     setProgressBarWidth(element?element[0]?.clientWidth:0)
    // },[])
    // // console.log("position i am window",this.displayRef)

    if(track === undefined || handler === undefined) {
        track = {}
        handler = () => {

        }
    }

    const enablehotKeys = () => {
        hotkeys('ctrl+alt+7, ctrl+alt+d', function (event, handler) {
            switch (handler.key) {
                case 'ctrl+alt+7':
                    setDragEnabled(true)
                    //console.log('enabled video seek', isDragEnabled)
                    break;
                case 'ctrl+alt+d':
                    setDragEnabled(false)
                    //console.log('disabled video seek', isDragEnabled)
                    break;
                default: return 1;
            }
        });
    }

    let videoJSOptions = {
        controls: true,
        autoplay: false,
        responsive: true,
        muted: false,
        playbackRates: [0.5,0.75,1, 1.25, 1.5, 1.75, 2],
        // poster: DataHelper.getResourcePath(0,poster),
        userActions: { hotkeys: true },
        controlBar: {
            volumePanel: true,
            pictureInPictureToggle: true
        }
    };

    if(!["","*"].includes(poster)){
     videoJSOptions = {
        ...videoJSOptions,
        poster: DataHelper.getResourcePath(0,poster)
    }
    }



    // const [overlayColor, setOverlayColor] = useState(colors.length > 0 ? colors[0].color: []);
    const [overlayColor, setOverlayColor] = useState([]);


    /**
    * Manage the component update 
    * progress logic in this method
    * 
    * Update the view status when ever the user interacts
    * Update the progess status ONLY ONCE, when status completes
    * 
    */
    const updateProgress = (currentItem) => {
        // console.log('track is', track)
        switch (currentItem.type) {
            case 'END':
                if (track?.status === 0) {
                    console.log('track video', track)
                    track.status = 1
                    setInstruct({
                        ...instruction,
                        text: `You have completed this interactivity`,
                        className: 'completed'
                    })
                    setStatus({ completed: true, text: PlayerConstants.COMPONENT_CONSTANTS.STATUS_COMPLETE })
                    handler({ type: SAVE_PROGRESS_STATUS, id: track?.id, name: cename })
                }
                break;
            case 'PLAYHEAD':
                if (!track?.status) {
                    track.status = 0
                } else if (!track?.state) {
                    track.state = { ...track.state, t: currentItem.time }
                }
                handler({ type: UPDATE_STATUS, id: track?.id, name: cename })
                break;
        }
    }

    const closeOverLay = () => {
        setOverLay(false);
        videoPlayerRef.current.play();
    }

    const showCuePoints = (cue) => {
        // cue.shown = true;
        // setCurrentCue(cue)
        if (cuepoints[cue].ctype != 5) {
            cuepoints[cue].shown = true;
            setCurrentCue(cuepoints[cue])
            /* Need to show content here */
            setOverLay(true)

            videoPlayerRef.current.pause();
            setOverlayColor([getColorByType(cuepoints[cue].ctype)])
        }

    }

    const getColorByType = (type) => {
        let colors = {
             0: { c: '#ffffff' },
             1: { c: '#ffffff' },
            2: { c: '#F3C465' },
            3: { c: '#81b84d' },
            4: { c: '#81b84d' },
            5: { c: '#81b84d' }
        }
        return colors[type].c
    }

    const renderCuePoints = (time) => {
        const tolerance = 0.12; // Adjust this value as needed
        for (const i in cuepoints) {
            const cuePointTime = Number(cuepoints[i].point);
            const isWithinTolerance = Math.abs(time - cuePointTime) < tolerance;
    
            if (isWithinTolerance ) {
                showCuePoints(i);
            }
        }
    };

    /**
     * generates the absolute URL for a video file based on the provided source.
     */
    const getAbsUrl = (src)=>{
        try{
            if(src){
                // extracts file details (like CCID and filename) from the source path.
                let formatted = getFileName(src);
                // constructs the absolute path using the constant base path, CCID, and filename.
                let path = PlayerConstants.CC_TXT_PATH + formatted.CCID+ '/' + formatted.filename + '.mp4';
                return path
            }
        }catch(e){
            console.log(e)
        }
    }
    

    const getVideoUrl = () => {
    try{
        let selected = { url: src, type: 'video/mp4' };
        let ar = src?.split('.');
        let ext = ar[ar.length - 1];
        if (ext === "m3u8") {
            selected.url = src;
            selected.type = 'application/x-mpegURL';
        }
        if((BuildHelper.isOnScorm() || BuildHelper.isOnXapi()) && ext === "m3u8")    {
            let vpath = src?.split('/')
            let spath = pathCreater(1)+vpath[vpath?.length-2]+'/'+vpath[vpath?.length-1];
            selected.url = spath;
            console.log("***********|||||||***********",selected)
        }
        return selected;
    }catch(e){
        return {url:getAbsUrl(src),type:'video/mp4'};
    }
    }
    /** if API serves file path then use this is get the TextVersion */

    // const getContentText = () => {
    //     let path = require(`../../../assets/data/text/${getVideoFileName(src)}.txt`).default
    //     fetch(path)
    //     .then(response => response).then(res => res.text())
    //     .then(text => setTextVersion(text))
    //     .catch(err => setTextVersion('No Content Found'))
    // }

    /** Should be there in middleware services 
     * TODO
    */

    // const getSubtitle = () => {
    //     const options = {
    //         headers :{
    //             'Authorization': window.ce?.platform_scorm?.authtoken
    //         }
    //     }
    //     let path = "https://d14rwvged4djyq.cloudfront.net/type3/87/subtitlevtt/CEIntro_IMP_S2_M1.vtt";
    //     fetch(path, options.headers)
    //     .then(data => data.json())
    //     .then(res => console.log('subtitle =>', res.data))
    //     .catch(err => console.log('Error in subtitle response'))
    // }

    const cueRender=(playerEle)=>{
        const progressControl = playerEle.controlBar.progressControl.seekBar.el();
        const customDiv = document.createElement("div");
        customDiv.className = "custom-progress-div";
        const customProgressDiv = document.querySelector(".custom-progress-div");
        //if the element exists before attempting to removing it
        if (customProgressDiv) {customProgressDiv.remove();}
        setControlArea({parentEel:progressControl,cueEle:customDiv});
    }
    let errorHandled = false;
    useEffect(() => {
        // getContentText()
        // getSubtitle()
        if (videoPlayerRef) {
            let videoInfo = getVideoUrl();
            let player = videojs(videoPlayerRef.current, videoJSOptions, () => {
                player.src({
                    src: `${videoInfo?.url}#t=0.5`,
                    type: videoInfo?.type,
                });
                player.on('loadedmetadata', () => { })
                player.on('loadstart', () => { });
                player.on('ready', () => {
               // playback rate menu styles
                    setTimeout(() => {
                        const items = document.querySelectorAll('.vjs-playback-rate .vjs-menu-item .vjs-menu-item-text');
                        items.forEach(item => {
                            const text = item.innerText.trim();
                            if (playbackRate[text]) {
                            item.innerText = playbackRate[text];
                            }
                        });
                         // update selected label shown on the control
                        const selectedRates = document.querySelectorAll('.vjs-playback-rate-value');
                        selectedRates?.forEach(rateEl => {
                            const text = rateEl.innerText.trim();
                            if (playbackRate[text]) {
                            rateEl.innerText = playbackRate[text];
                            }
                        });

                    }, 1000);

                });
                player.on('play', (e) => {
                    setPlayerReady(true);
                    addCuePoint();
                });
                player.on('ratechange', () => {
                   const selectedRates = document.querySelectorAll('.vjs-playback-rate-value');
                    if (selectedRates) {
                         selectedRates?.forEach(rateEl => {
                            const text = rateEl.innerText.trim();
                            if (playbackRate[text]) {
                            rateEl.innerText = playbackRate[text];
                            }
                        });

                    }
                });
                player.on('playing', (e) => {
                    // console.log('duration', Math.floor(videoPlayerRef.current.duration))
                    setDuration(Math.floor(videoPlayerRef.current.duration))
                    const mediaEle = document.querySelectorAll('video, audio')
                    for (const media of mediaEle) {
                        if (media !== e.target.children[0]) {
                            media.pause()
                        }
                    }
                })

                player.on("ended", () => {
                    updateProgress({ type: 'END' });
                    if (player.isFullscreen()) {
                        setTimeout(() => {
                          player.exitFullscreen(); 
                        }, 100); // Wait for the duration
                      }
                    for (const i of cuepoints) {
                        i.shown = false
                    }
                });
                player.on('error', (e) => {
                    if (!errorHandled) {
                      player.src(getAbsUrl(src));
                      player.load();
                      // player.play();
                      errorHandled = true;
                    }
                  });
                player.on("timeupdate", () => {
                    if (!BuildHelper.isOnScorm()){
                    updateProgress({ type: 'PLAYHEAD', time: player.currentTime() })
                    }
                    if (cuepoints?.length > 0) {
                        try {
                            renderCuePoints(player.currentTime())
                        } catch (e) {
                            console.debug(e);
                        }
                    }
                });
            });
            cueRender(player)
            setPlayer(player);
        }
    }, [src]);

    useEffect(()=>{ 
        try{ cueRender(player);}catch(e){} 
    },[cuepoints])

    useEffect(() => {
        enablehotKeys()
        let controlBar = document.querySelectorAll('.vjs-progress-control')
        if (isDragEnabled) {
            controlBar.forEach(el => el.style.pointerEvents = 'initial')
        } else {
            controlBar.forEach(el => el.style.pointerEvents = 'none')
        }
    }, [isDragEnabled])

    const handleTextVersion = () => {
        setTextVersionVersion(true)
        videoPlayerRef?.current?.pause();
    }

    const closeTextOverlay = () => {
        setTextVersionVersion(false)
        videoPlayerRef?.current?.play();
    }

    const getCueList = (list) => {
        const mapped = list?.map((el) => {
            return new CuePoint(el)
        });
        return mapped;
    }

    const getFileName = (src) => {
        if (!src) return { filename: '', CCID: '' }; // Handle if src is null or undefined
        let srcUrl = src.split('/');
        
        let isMp4 = src.includes('.mp4');
        let filename, CCID;
        
        if (isMp4) {
            filename = srcUrl[5].replace('.mp4', ''); // For the case where .mp4 exists in the URL and Remove .mp4 extension
            CCID = srcUrl[4];
        } else {
            filename = srcUrl[4]; // For the case where .m3u8 exists in the URL
            CCID = srcUrl[3];
        }
        
        return { filename, CCID };
    };

    /**
     * Archived video file is served from streamed location 
     * Need to plan for subtitle handling
     * Previous version of player .srt files ..current version player supports only .vtt files
     * TODO
     */
    //  https://d14rwvged4djyq.cloudfront.net/type3/87/subtitlevtt/CEIntro_IMP_S2_M1.vtt
    const getSubtitlePath = () => {
        try {
            // https://assets.contentenablers.com/rlm/topics/616d1ae6424d275113d542bb/TCO_UK_FI_Intro.vtt
            if(src && !(BuildHelper.isOnScorm() || BuildHelper.isOnXapi())){
                let formatted = getFileName(src);
                let path = PlayerConstants.CC_TXT_PATH + formatted.CCID + '/subtitlevtt/' + formatted.filename + '.vtt';
                return path;
            }
            else if(BuildHelper.isOnScorm() || BuildHelper.isOnXapi()){
                let ar = src.split('/');
                let file = ar[ar?.length-1];
                let fn = file.split('.')
                if(fn[fn.length-1] === "m3u8" && (BuildHelper.isOnXapi() || BuildHelper.isOnScorm())){
                    file = ar[ar?.length-2];
                    fn = [file]
                }
                // let formatted = getFileName(src);
                return BuildHelper.getExternalPath()  + `./content/${BuildHelper?.defaultLanguage() || 'en_US'}/subtitlevtt/${fn[0]}.vtt`;
            }
            else{
                return "http://d14rwvged4djyq.cloudfront.net/type3/81/subtitlevtt/NZL_IMP_S3_M8.vtt"
            }
          

        } catch (err) {
            console.log("err", err);
            setCCTextVersion(false);
            return require(`../../../assets/data/subtitle/subtitle_eng.vtt`).default
        }

    }

    const timeSeek = (secs) => {
        let time = player.currentTime() + secs;
        if (time < 0) {
            time = 0;
        }
        player.currentTime(time);
    }

    const forward = () => {
        timeSeek(10);
    }

    const rewind = () => {
        timeSeek(-10);
    }
   

  const onResize = (e) => {
    if(e.target?.innerText?.trim()=="Mobile"||e.target?.innerText?.trim()=="Tablet"||e.target?.innerText?.trim()=="Laptop"||e.target?.innerText?.trim()=="Desktop"){
        setViewDevice(e.target?.innerText?.trim())
    }
}

  React.useEffect(() => {
    window.addEventListener("mousedown", onResize);
    return () => {
      window.removeEventListener("mousedown", onResize);
    };
  }, []);

/* Cue Point add & edit */
const editPanelOpen = (edit) => {
    if(!BuildHelper.isLearner() && hasCue){
        let editItem = edit
        if (edit !== -1) { editItem = { ...edit }; player.currentTime(edit?.time);};
        let curentTime=(Math.round(player.currentTime() * 100) / 100).toFixed(2);
        handler({ type: ComponentConstants?.SAVE_COMP_PROPS, data: { cename, topic_id, cduration:curentTime, isEdit: editItem } })
        if (edit === -1) setCurrentCue(cuepoints?.length - 1);
         // if(edit===-1){
        //     let newCue = {
        //         data:{content: "Content",},
        //         content: "Content",
        //         cuePlot: 40,
        //         id: cuepoints.length + 1,
        //         shown: false,
        //         time: player.currentTime(edit?.time),
        //         title: "",
        //         type: 1
        //     }
        //     cuepoints.push(newCue);
        // }
    }
}


/* add cuepoints */
const addCuePoint=()=>{
    if(!BuildHelper.isLearner() && hasCue){
        setDragEnabled(true);
        let isButtonCheck = document.querySelectorAll('.vjs-playing .vjs-play-progress .add-video-sub');
        if (playerReady && !isButtonCheck[0]) {
            let playProgress = document.querySelectorAll('.vjs-playing .vjs-play-progress');
            let html = `+<br><span class="current-time">${formatTime(videoPlayerRef.current.currentTime)}</span>`; // Display current time
            let div = document.createElement('div');
            for (var i = 0; i < playProgress?.length; i++) {
                playProgress[i].appendChild(div);
            }
            div.addEventListener('click', function (event) {
                player.pause();
                editPanelOpen(-1);
                event.preventDefault();
            });
            div.innerHTML = html;
            div.classList.add("add-video-sub");
            div.setAttribute("data-gloss", 'Add  Cuepoints');
            setInterval(() => {
                const currentTimeSpan = div.querySelector('span');
                if (currentTimeSpan) {
                    currentTimeSpan.textContent = formatTime(videoPlayerRef.current.currentTime);
                }
            }, 1000);
            
        }
    } else {document.querySelector('.vjs-progress-holder').setAttribute('tabindex', '-1');} //remove focusability from the progress holder
}
function formatTime(seconds) {
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = Math.floor(seconds % 60);
    return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
}
function padZero(num) {
    return (num < 10 ? '0' : '') + num;
}
const isCueCheck = (cue) => {
    try {
        for (var i in cuepoints) {
            if (cuepoints[i]?.point === cue?.point) {
                return true
            }
        }
        videoPlayerRef.current.play();
        return false;
    } catch (e) { }
}


const setupOptions = {
    fluid: true,
    language: BuildHelper.defaultLanguage(),
    languages: {
        [BuildHelper.defaultLanguage()]:{
            Play: t('PLAY'),
            Pause: t('PAUSE'),
            Mute: t('MUTE'),
            Unmute: t('UNMUTE'),
            Fullscreen: t('FULL_SCREEN'),
            'Exit Fullscreen': t('EXIT_FULL_SCREEN'),
            Captions: t('CAPTIONS'),
            Subtitles: t('SUBTITLES'),
            Chapters: t('CHAPTERS'),
            Settings: t('SETTINGS'),
            Replay:t('REPLAY'),
          'subtitles off':t('CAPTION_OFF')
        }
    }
};

    return (
        <>
            <Instruction isInstruction={instruction?.enabled} completed={(track?.status > 0 || status?.completed)} title={(track?.status > 0 || status?.completed) ? PlayerConstants.COMPONENT_CONSTANTS.STATUS_COMPLETE : PlayerConstants.COMPONENT_CONSTANTS.STATUS_INCOMPLETE} classText={`${(track?.status > 0 || status?.completed) && PlayerConstants.COMPONENT_CONSTANTS.COMPLETED_CLASS}`} text={(track?.status > 0 || status?.completed) ? PlayerConstants.COMPONENT_CONSTANTS.INSTRUCTIONS_PASSED : instruction?.text}/>
            <div className={`video-container ${!playbackRates ? `non-playbackRates` : 'playbackRates'} ` } onMouseOver={addCuePoint}>
                <video
                    oncontextmenu="return false;"
                    ref={videoPlayerRef}
                    controls={false}
                    muted
                    playsInline
                    webkit-playsinline="true"
                    className="video-js"
                    data-setup={JSON.stringify(setupOptions)}
                >

       <track kind='captions' src={getSubtitlePath()} srcLang='en' label={t('LANGUAGE_N')} default={has_cc}
        mode={(showCCTextVersion) ? 'showing' : 'hidden'} />
                </video>
                <button className='vjs-video-text-version non-active-btn br-5'  onClick={handleTextVersion} title={t('TEXT_VERSION')}>
                    <SubtitlesIcon className='video-text-icon' />
                </button>
                {playerReady && cuepoints?.length !== 0 && <CuePoints data={getCueList(cuepoints)} duration={duration} viewInDevice={viewInDevice} onClick={(i) => editPanelOpen(i)} parent={controlArea} />}
                {isOverLay && isCueCheck(currentCue) && currentCue?.ctype != 5 && <OverLayRender type={currentCue?.ctype} data={currentCue} bgcolor={overlayColor} close={() => closeOverLay()} userInfo={userInfo}/>}
                {showTextVersion && <VideoContentText contentText={content} close={() => closeTextOverlay()} />}
                {(readable || description) && <div className='readable-text' dangerouslySetInnerHTML={{ __html: description ? description : readable }}></div>}
            </div>
            {forward_rewind && <div className="forward-backward-btns">
                <MuiIcons iconName="Replay10" className="backward"  onClick={ () => rewind()} />
               { fast_forward && <MuiIcons iconName="Forward10" className="forward" onClick={ () => forward()} />}
                {/* <img alt='forward-icon' className="forward" src={require(`../../../assets/img/forward-ten_1.png`).default} onClick={() => forward()} />
                <img alt='backward-icon' className="backward" src={require(`../../../assets/img/back-ten_1.png`).default} onClick={() => rewind()} /> */}
            </div>}
        </>
    );
};


ArchiveVideo.defaultProps = {
    instructions: {
        text: 'Click on the play button to view the video below.',
        enabled: false
    }
}

ArchiveVideo.propTypes = {
    /** Video source url of the component */
    src: PropTypes.string.isRequired,
    /** Poster Url for background overlay image */
    poster: PropTypes.string,
    // /** Innerhtml string for rendering some content* */
    readable: PropTypes.string,
    /** Cuepoints array for the video for the displaying message */
    cuepoints: PropTypes.array,
    /** Display colors of the cuepoints overlay*/
    colors: PropTypes.array,
    /** Tracking the component progress */
    track: PropTypes.object,
    /** Func description for tracking*/
    handler: PropTypes.func,
    /** Cename describes name of component*/
    cename: PropTypes.string

};

export  const playbackRate = {
'0.5x': '0.5',
'0.75x': '0.75',
'1x': 'Normal',
'1.25x': '1.25',
'1.5x': '1.5',
'1.75x': '1.75',
'2x': '2',
};

export default ArchiveVideo